CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
{ PluginData } = require 'app/scripts/models/PluginData'
Promise = require 'bluebird'
_ = require 'underscore'
xtend = require 'xtend'

class PluginDataList extends CollectionWithHelpers
  model: PluginData

  initialize: (models, options) ->
    @scopeModel = options.scopeModel

  scope: ->
    @scopeModel.typeName.toLowerCase()

  for: (idPlugin, visibility) ->
    _.find @models, (model) =>
      model.get('idPlugin') == idPlugin &&
      model.get('access') == visibility &&
      model.get('scope') == @scope() &&
      model.get('idModel') == @scopeModel.id

  create: (attributes, options) ->
    attributes = xtend attributes,
      scope: @scope()
      idModel: @scopeModel.id
      access: attributes.visibility

    super(attributes, options)

  dataForPlugin: (idPlugin) ->
    _.chain(@models)
    .filter (entry) -> entry.get('idPlugin') == idPlugin
    .groupBy (entry) -> entry.get('scope')
    .mapObject (val) ->
      _.chain(val)
      .groupBy (entry) -> entry.get('access')
      .mapObject (val) -> val[0].get('value')
      .value()
    .value()

  getPluginDataByKey: (idPlugin, scope, visibility, key, defaultVal) ->
    data = @dataForPlugin(idPlugin)
    if typeof data?[scope]?[visibility] == 'string'
      parsed = JSON.parse(data[scope][visibility])
      if typeof parsed == 'object' && parsed[key] != undefined
        return parsed[key]
    return defaultVal

  snoopDataForPlugin: (idPlugin) ->
    if !@signalCache?
      @signalCache = {}
    if !@signalCache[idPlugin]?
      @signalCache[idPlugin] = @snoop('value').map => @dataForPlugin(idPlugin)
      @signalCache[idPlugin].addDisposer => delete @signalCache[idPlugin]
    @signalCache[idPlugin]

  upsert: (idPlugin, visibility, data) ->
    pluginData = @for(idPlugin, visibility)
    if pluginData?
      pluginData.update('value', data)
    else
      @create
        idPlugin: idPlugin
        visibility: visibility
        value: data
    return

  setPluginDataByKey: (idPlugin, scope, visibility, key, val) ->
    data = @dataForPlugin(idPlugin)
    updatedData = {}
    updatedData[key] = val
    if typeof data?[scope]?[visibility] == 'string'
      parsed = JSON.parse(data[scope][visibility])
      if typeof parsed == 'object'
        parsed[key] = val
        updatedData = parsed
    @upsert(idPlugin, visibility, JSON.stringify(updatedData))

module.exports = PluginDataList
